// Firebase Analytics utility functions
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

// Helper function to check if analytics is available
const isAnalyticsAvailable = () => {
  return analytics !== null && analytics !== undefined;
};

// Track page views
export const trackPageView = (path) => {
  if (!isAnalyticsAvailable()) return;

  logEvent(analytics, 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (!isAnalyticsAvailable()) return;

  logEvent(analytics, eventName, eventParams);
};

// Track product views
export const trackProductView = (product) => {
  if (!isAnalyticsAvailable() || !product) return;

  logEvent(analytics, 'view_item', {
    currency: 'ZAR',
    value: product.price,
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        price: product.price,
        quantity: 1,
      },
    ],
  });
};

// Track add to cart
export const trackAddToCart = (product, quantity = 1) => {
  if (!isAnalyticsAvailable() || !product) return;

  logEvent(analytics, 'add_to_cart', {
    currency: 'ZAR',
    value: product.price * quantity,
    items: [
      {
        item_id: product.id,
        item_name: product.name,
        price: product.price,
        quantity: quantity,
      },
    ],
  });
};

// Track orders/purchases
export const trackPurchase = (orderId, items, total) => {
  if (!isAnalyticsAvailable()) return;

  logEvent(analytics, 'purchase', {
    transaction_id: orderId,
    value: total,
    currency: 'ZAR',
    items: items.map((item) => ({
      item_id: item.productId || item.id,
      item_name: item.name,
      price: item.price,
      quantity: item.quantity,
    })),
  });
};

// Track search queries
export const trackSearch = (searchTerm) => {
  if (!isAnalyticsAvailable() || !searchTerm) return;

  logEvent(analytics, 'search', {
    search_term: searchTerm,
  });
};

// Track category filter selections
export const trackCategoryFilter = (category) => {
  if (!isAnalyticsAvailable() || !category) return;

  logEvent(analytics, 'category_filter', {
    category: category,
  });
};

// Track social media clicks
export const trackSocialClick = (platform) => {
  if (!isAnalyticsAvailable() || !platform) return;

  logEvent(analytics, 'social_click', {
    platform: platform,
  });
};

// Track contact form submissions
export const trackContactSubmission = () => {
  if (!isAnalyticsAvailable()) return;

  logEvent(analytics, 'contact_form_submit');
};

// Track product shares
export const trackProductShare = (product, method) => {
  if (!isAnalyticsAvailable() || !product) return;

  logEvent(analytics, 'share', {
    method: method, // 'web_share', 'clipboard', etc.
    content_type: 'product',
    item_id: product.id,
  });
};
